import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Home from './pages/Home';
import Result from './pages/Result';
import Navbar from './components/Navbar';

function App() {
  return (
    <Router>
      <div className="App bg-gray-800">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/result" element={<Result />} />

        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
